import React, { useContext } from "react";

import { UserContext } from "../../../contexts";

import BubbleView from "./BubbleView";

const Bubble = ({ name, where = "menu", priceCount = 0 }) => {
  const { notifications } = useContext(UserContext);

  const arr = Array.isArray(name) ? name : [name];
  const count = arr.reduce(
    (sum, name) => sum + (notifications?.[name] || 0),
    0
  );

  if (priceCount !== 0) {
    return <BubbleView count={priceCount} where="price-list-count" />;
  }

  if (!count) {
    return null;
  }

  return <BubbleView count={count} where={where} />;
};

export default Bubble;
